import useResizeObserver from '@react-hook/resize-observer';
import { RefObject, useLayoutEffect, useState } from 'react';

export const useBoundingClientRect = (ref: RefObject<Element>) => {
    const [boundingClientRect, setBoundingClientRect] = useState<DOMRect>({
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0,
        toJSON: () => {}
    });

    useLayoutEffect(() => {
        if (!ref?.current) {
            return;
        }
        setBoundingClientRect(ref.current.getBoundingClientRect());
    }, [ref]);

    useResizeObserver(ref, (entry) => setBoundingClientRect(entry.contentRect));
    return boundingClientRect;
};
